import { render, staticRenderFns } from "./SvgClock.vue?vue&type=template&id=01773ad4&"
import script from "./SvgClock.vue?vue&type=script&lang=js&"
export * from "./SvgClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports